import styled, { keyframes } from "styled-components";

import { ScrollZone } from "../../../Components";
import { GatsbyImage } from "../../../../../../components/GatsbyImage";

const opacityAutoChange = keyframes`
    0% { opacity: 0; }
    10% { opacity: 1; }
    20%, 100% { opacity: 0; }
`;

const opacityHoverChange = keyframes`
    0% { opacity: 0; }
    20% { opacity: 1; }
    40%, 100% { opacity: 0; }
`;

export const Functionality = styled(ScrollZone.SlideContainer)`
  display: flex;
  flex-direction: column;
  background-color: ${props => props.theme.palette.grey20};
  border-radius: ${props => props.theme.border.radius.base};
  padding: ${({ theme }) => theme.spacing.spacing_24} 0;
  align-items: center;
  min-height: 100%;

  width: 292px;

  ${props => props.theme.breakpoints.tablet} {
    width: 288px;
  }

  ${props => props.theme.breakpoints.desktop} {
    width: 356px;
  }
`;

export const ImageWrapper = styled.figure`
  margin-bottom: ${({ theme }) => theme.spacing.spacing_24};
  position: relative;
  height: 400px;
  width: 100%;

  ${props => props.theme.breakpoints.desktopLarge} {
    margin-bottom: ${({ theme }) => theme.spacing.spacing_32};
    height: 480px;
  }
`;

export const ImageBase = styled(GatsbyImage).attrs({
  objectFit: "contain",
})`
  position: absolute !important;
  opacity: 0;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
  height: 100%;
  width: 100%;
`;

export const Image = styled(ImageBase)`
  opacity: 1;
`;

export const SecondImage = styled(ImageBase)`
  animation: ${opacityAutoChange} 4s 2s infinite ease;

  ${props => props.theme.breakpoints.desktop} {
    animation: none;
    &:hover {
      animation: ${opacityHoverChange} 3s 0.5s infinite ease;
    }
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 ${({ theme }) => theme.spacing.spacing_24};
  gap: ${({ theme }) => theme.spacing.spacing_8};
  justify-content: center;
`;
